import React, { useEffect } from 'react';

const AutoTranslator = () => {
  useEffect(() => {
    // 1. Define the initialization function for Google Translate
    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: 'en',
          autoDisplay: false,
        },
        'google_translate_element'
      );
    };

    // 2. Load the Google Translate script if it hasn't been loaded yet
    const id = 'google-translate-script';
    if (!document.getElementById(id)) {
      const script = document.createElement('script');
      script.id = id;
      script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      document.body.appendChild(script);
    }

    // 3. Inject CSS to hide Google Translate toolbar & banners
    const style = document.createElement('style');
    style.innerHTML = `
      .goog-te-banner-frame,
      .goog-te-banner-frame.skiptranslate,
      .goog-te-banner,
      .goog-te-balloon-frame,
      #goog-gt-tt,
      #goog-gt-tt.skiptranslate,
      .goog-tooltip,
      .goog-tooltip:hover,
      .goog-te-gadget-icon {
        display: none !important;
        visibility: hidden !important;
        height: 0 !important;
        width: 0 !important;
        opacity: 0 !important;
      }
      body, html {
        top: 0 !important;
        position: static !important;
        margin-top: 0 !important;
      }
      .goog-text-highlight {
        background-color: transparent !important;
        box-shadow: none !important;
        border: none !important;
      }
    `;
    document.head.appendChild(style);

    // 4. Forcefully hide Google Translate toolbar if it appears
    const hideElements = () => {
      const selectors = [
        '.goog-te-banner-frame',
        '.goog-te-banner',
        '#goog-gt-tt',
        '.goog-tooltip',
        '.goog-te-balloon-frame',
        'iframe[title="Language Translate Widget"]',
        'iframe.skiptranslate',
        'iframe[id*=":0.container"]',
        '.skiptranslate'
      ];

      selectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(el => {
          if (selector !== '.skiptranslate' || el.tagName === 'IFRAME') {
            el.style.setProperty('display', 'none', 'important');
            el.style.setProperty('visibility', 'hidden', 'important');
            el.style.setProperty('height', '0', 'important');
          }
        });
      });

      document.body.style.setProperty('top', '0px', 'important');
      document.body.style.setProperty('margin-top', '0px', 'important');
      document.documentElement.style.setProperty('top', '0px', 'important');
    };

    const observer = new MutationObserver(hideElements);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    const interval = setInterval(hideElements, 100);

    return () => {
      observer.disconnect();
      clearInterval(interval);
      if (style.parentNode) style.parentNode.removeChild(style);
    };
  }, []);

  return (
    <div id="google_translate_element" style={{ display: 'none' }}></div>
  );
};

// Helper function to change language via cookie
export const changeWebsiteLanguage = (langCode) => {
  const cookieValue = `/en/${langCode}`;

  // Set for all domain variants
  document.cookie = `googtrans=${cookieValue}; path=/`;
  document.cookie = `googtrans=${cookieValue}; path=/; domain=.${window.location.hostname}`;

  // Reload the page to trigger translation
  window.location.reload();
};

// Re-trigger Google Translate on SPA page navigation
// Google Translate only translates on initial load. When React swaps page
// components, the new DOM content stays in English. This function forces
// Google Translate to re-scan and translate the new content.
export const retriggerTranslation = () => {
  setTimeout(() => {
    const combo = document.querySelector('.goog-te-combo');
    if (combo && combo.value && combo.value !== 'en') {
      // Fire the change event to re-trigger translation on new DOM nodes
      combo.dispatchEvent(new Event('change'));
    }
  }, 300);
};

export default AutoTranslator;
